var map = {
	"./grade1.png": "4a5b",
	"./grade2.png": "1a34",
	"./grade3.png": "61e7",
	"./grade4.png": "bd88",
	"./graden1.png": "912b",
	"./graden2.png": "3762",
	"./graden3.png": "5dc7",
	"./graden4.png": "0dac",
	"./graden5.png": "e6f4",
	"./graden6.png": "10f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d1c";